export default "__VITE_ASSET__a2acbb99__"